<template>
    <div class="col-12 col-md-6">
        <div class="card card-profile card-plain h-100 d-flex flex-column">

            <div class="row no-gutters flex-grow-1">
                <!-- cover -->
                <div class="col-12 col-md-5 d-flex align-items-center" v-if="hasCoverImage">
                    <router-link :to="'/product/' + gtin" class="mx-auto">
                        <div class="card-header card-header-image mb-0">
                            <img
                                class="img img-cover"
                                :src="mediumCover"
                                :alt="'Coverbild für ' + article.configuration.name + ' von ' + article.artist + ' mit dem Titel ' + article.title"
                                role="img"
                                />
                        </div>
                    </router-link>
                </div>

                <!-- details -->
                <div class="col-12 col-md-7 d-flex flex-column">
                    <div class="card-body p-3 flex-grow-1">
                        <div class="h5 card-title mb-2 title-clamp">
                            <router-link :to="'/product/' + gtin">
                                {{ article.title }}
                            </router-link>
                        </div>

                        <dl class="dl-compact mb-2">
                            <template v-if="article.physical_release_date">
                                <dt>{{ $t('product.release_date') }}:</dt>
                                <dd>{{ dateFormat(article.physical_release_date) }}</dd>
                            </template>

                            <dt>{{ $t('product.genre') }}:</dt>
                            <dd>{{ article.genre.name }}</dd>

                            <dt>{{ $t('product.configuration') }}:</dt>
                            <dd>{{ article.configuration.name }} ({{ article.set_total }})</dd>
                        </dl>
                    </div>

                    <!-- action slot at bottom -->
                    <div class="card-footer d-flex justify-content-end p-2 border-0 mt-auto">
                        <router-link
                            v-if="hasStreaming"
                            :to="'/product/' + gtin"
                            class="btn btn-just-icon btn-github btn-round"
                            :title="$t('product.sample_exists')"
                            :aria-label="$t('product.sample_exists')"
                            >
                            <i class="material-icons" aria-hidden="true">headset</i>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import isString from 'lodash-es/isString'

export default {
  name: 'ListProductComponent',
  props: ['id', 'article'],
  computed: {
    gtin () {
      return this.article.gtin
    },
    cover () {
      try {
        if (isString(this.$props.article.artworks.artwork[0].url)) {
          return this.$props.article.artworks.artwork[0].url
        }
      } catch (err) {
        return null
      }
    },
    mediumCover: function () {
      if (isString(this.cover)) {
        return this.cover.replace('0080px', '0300px')
      }
      return null
    },
    hasCoverImage () {
      return this.article.has_cover
    },
    hasStreaming () {
      return this.article.has_tracks === true && this.article.has_sound
    }
  },
  methods: {
    dateFormat (date) {
      return moment(date).format('DD.MM.YYYY')
    }
  }
}
</script>

<style scoped>

</style>
